var SeatStock, is_sp, spnav;

require("jquery.easing");

require("jquery.mousewheel");

require("jquery.jscrollpane");

require("mwheelIntent");

SeatStock = require("./lib/seat-stock");

is_sp = require("./lib/check-smartphone");

spnav = require("./lib/spnav");

$(function() {
  var $body, $top_nav, $window, floatingNav, footer_height, header_height, nav_height, offset_nav_top, spInit, ua, win_height;
  SeatStock.sync();
  $window = $(window);
  $body = $("body");
  $top_nav = $("#top-nav");
  if (!is_sp) {
    $(".update-list").jScrollPane({
      verticalDragMaxHeight: 11,
      horizontalDragMaxWidth: 11
    });
  }
  header_height = $("#pagecatch").height();
  nav_height = $top_nav.height();
  offset_nav_top = $top_nav.offset().top;
  footer_height = $("#pagefooter").height();
  win_height = $window.height() - footer_height;
  floatingNav = function() {
    var pagenav, scrollTop;
    scrollTop = $window.scrollTop();
    if (offset_nav_top <= scrollTop + 30) {
      pagenav = $("#pagenav");
      pagenav.children("#top-nav").addClass("hidden");
      pagenav.children("#inner-nav").removeClass("hidden");
      pagenav.children("#inner-logo").removeClass("offscreen");
      return $("#side-nav").removeClass("collapse");
    } else {
      pagenav = $("#pagenav");
      pagenav.children("#inner-logo").addClass("offscreen");
      $("#side-nav").addClass("collapse");
      pagenav.children("#inner-nav").addClass("hidden");
      return pagenav.children("#top-nav").removeClass("hidden");
    }
  };
  spInit = function() {
    $body.addClass("sp");
    $("#inner-nav").addClass("collapse");
    return $("#side-nav").addClass("collapse");
  };
  ua = navigator.userAgent;
  if (ua.search(/iPhone|iPad|iPod|Android/) === -1) {
    $window.on("load resize scroll", function() {
      return floatingNav();
    });
  } else {
    if (!is_sp) {
      $window.on("load resize touchmove", function() {
        return floatingNav();
      });
    }
  }
  if (is_sp) {
    $window.on("load", function() {
      return spInit();
    });
  }
  $("a[href ^= '#']").on("click", function() {
    var href, speed, target, target_offset;
    speed = 300;
    href = $(this).attr("href");
    if (href === "#" || href === "") {
      href = "html";
    }
    target = $(href);
    target_offset = target.offset().top;
    if (is_sp && !(href === "html")) {
      target_offset += 150;
    }
    $('html,body').animate({
      scrollTop: target_offset
    }, 400, "easeInOutQuart");
    if (!is_sp) {
      setTimeout(floatingNav, 500);
    }
    return false;
  });
  if (is_sp) {
    spnav();
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxPQUFBLENBQVEsZUFBUjs7QUFDQSxPQUFBLENBQVEsbUJBQVI7O0FBQ0EsT0FBQSxDQUFRLG9CQUFSOztBQUNBLE9BQUEsQ0FBUSxjQUFSOztBQUVBLFNBQUEsR0FBWSxPQUFBLENBQVEsa0JBQVI7O0FBQ1osS0FBQSxHQUFRLE9BQUEsQ0FBUSx3QkFBUjs7QUFDUixLQUFBLEdBQVEsT0FBQSxDQUFRLGFBQVI7O0FBR1IsQ0FBQSxDQUFFLFNBQUE7QUFFRCxNQUFBO0VBQUEsU0FBUyxDQUFDLElBQVYsQ0FBQTtFQUtBLE9BQUEsR0FBVSxDQUFBLENBQUUsTUFBRjtFQUNWLEtBQUEsR0FBUSxDQUFBLENBQUUsTUFBRjtFQUNSLFFBQUEsR0FBVyxDQUFBLENBQUUsVUFBRjtFQU1YLElBQUEsQ0FBTyxLQUFQO0lBQ0MsQ0FBQSxDQUFFLGNBQUYsQ0FBaUIsQ0FBQyxXQUFsQixDQUNDO01BQUEscUJBQUEsRUFBd0IsRUFBeEI7TUFDQSxzQkFBQSxFQUF5QixFQUR6QjtLQURELEVBREQ7O0VBTUEsYUFBQSxHQUFnQixDQUFBLENBQUUsWUFBRixDQUFlLENBQUMsTUFBaEIsQ0FBQTtFQUNoQixVQUFBLEdBQWEsUUFBUSxDQUFDLE1BQVQsQ0FBQTtFQUNiLGNBQUEsR0FBaUIsUUFBUSxDQUFDLE1BQVQsQ0FBQSxDQUFpQixDQUFDO0VBQ25DLGFBQUEsR0FBZ0IsQ0FBQSxDQUFFLGFBQUYsQ0FBZ0IsQ0FBQyxNQUFqQixDQUFBO0VBQ2hCLFVBQUEsR0FBYSxPQUFPLENBQUMsTUFBUixDQUFBLENBQUEsR0FBbUI7RUFnQmhDLFdBQUEsR0FBYyxTQUFBO0FBQ2IsUUFBQTtJQUFBLFNBQUEsR0FBWSxPQUFPLENBQUMsU0FBUixDQUFBO0lBVVosSUFBRyxjQUFBLElBQW1CLFNBQUEsR0FBWSxFQUFsQztNQUNDLE9BQUEsR0FBVSxDQUFBLENBQUUsVUFBRjtNQUVWLE9BQU8sQ0FBQyxRQUFSLENBQWlCLFVBQWpCLENBQTRCLENBQUMsUUFBN0IsQ0FBc0MsUUFBdEM7TUFDQSxPQUFPLENBQUMsUUFBUixDQUFpQixZQUFqQixDQUE4QixDQUFDLFdBQS9CLENBQTJDLFFBQTNDO01BQ0EsT0FBTyxDQUFDLFFBQVIsQ0FBaUIsYUFBakIsQ0FBK0IsQ0FBQyxXQUFoQyxDQUE0QyxXQUE1QzthQUNBLENBQUEsQ0FBRSxXQUFGLENBQWMsQ0FBQyxXQUFmLENBQTJCLFVBQTNCLEVBTkQ7S0FBQSxNQUFBO01BU0MsT0FBQSxHQUFVLENBQUEsQ0FBRSxVQUFGO01BRVYsT0FBTyxDQUFDLFFBQVIsQ0FBaUIsYUFBakIsQ0FBK0IsQ0FBQyxRQUFoQyxDQUF5QyxXQUF6QztNQUNBLENBQUEsQ0FBRSxXQUFGLENBQWMsQ0FBQyxRQUFmLENBQXdCLFVBQXhCO01BQ0EsT0FBTyxDQUFDLFFBQVIsQ0FBaUIsWUFBakIsQ0FBOEIsQ0FBQyxRQUEvQixDQUF3QyxRQUF4QzthQUNBLE9BQU8sQ0FBQyxRQUFSLENBQWlCLFVBQWpCLENBQTRCLENBQUMsV0FBN0IsQ0FBeUMsUUFBekMsRUFkRDs7RUFYYTtFQW1DZCxNQUFBLEdBQVMsU0FBQTtJQUNSLEtBQUssQ0FBQyxRQUFOLENBQWUsSUFBZjtJQUVBLENBQUEsQ0FBRSxZQUFGLENBQWUsQ0FBQyxRQUFoQixDQUF5QixVQUF6QjtXQUNBLENBQUEsQ0FBRSxXQUFGLENBQWMsQ0FBQyxRQUFmLENBQXdCLFVBQXhCO0VBSlE7RUFlVCxFQUFBLEdBQUssU0FBUyxDQUFDO0VBQ2YsSUFBRyxFQUFFLENBQUMsTUFBSCxDQUFVLDBCQUFWLENBQUEsS0FBeUMsQ0FBQyxDQUE3QztJQUtDLE9BQU8sQ0FBQyxFQUFSLENBQVcsb0JBQVgsRUFBaUMsU0FBQTthQUNoQyxXQUFBLENBQUE7SUFEZ0MsQ0FBakMsRUFMRDtHQUFBLE1BQUE7SUFVQyxJQUFHLENBQUMsS0FBSjtNQUNDLE9BQU8sQ0FBQyxFQUFSLENBQVcsdUJBQVgsRUFBb0MsU0FBQTtlQUNuQyxXQUFBLENBQUE7TUFEbUMsQ0FBcEMsRUFERDtLQVZEOztFQWNBLElBQUcsS0FBSDtJQUNDLE9BQU8sQ0FBQyxFQUFSLENBQVcsTUFBWCxFQUFtQixTQUFBO2FBQ2xCLE1BQUEsQ0FBQTtJQURrQixDQUFuQixFQUREOztFQVFBLENBQUEsQ0FBRSxnQkFBRixDQUFtQixDQUFDLEVBQXBCLENBQXVCLE9BQXZCLEVBQWdDLFNBQUE7QUFDL0IsUUFBQTtJQUFBLEtBQUEsR0FBUTtJQUNSLElBQUEsR0FBTyxDQUFBLENBQUUsSUFBRixDQUFJLENBQUMsSUFBTCxDQUFVLE1BQVY7SUFDUCxJQUFpQixJQUFBLEtBQVEsR0FBUixJQUFlLElBQUEsS0FBUSxFQUF4QztNQUFBLElBQUEsR0FBTyxPQUFQOztJQUNBLE1BQUEsR0FBUyxDQUFBLENBQUcsSUFBSDtJQUVULGFBQUEsR0FBaUIsTUFBTSxDQUFDLE1BQVAsQ0FBQSxDQUFlLENBQUM7SUFDakMsSUFBd0IsS0FBQSxJQUFTLENBQUMsQ0FBQyxJQUFBLEtBQVEsTUFBVCxDQUFsQztNQUFBLGFBQUEsSUFBaUIsSUFBakI7O0lBQ0EsQ0FBQSxDQUFFLFdBQUYsQ0FBYyxDQUFDLE9BQWYsQ0FBdUI7TUFBQyxTQUFBLEVBQVcsYUFBWjtLQUF2QixFQUFtRCxHQUFuRCxFQUF3RCxnQkFBeEQ7SUFDQSxJQUErQixDQUFDLEtBQWhDO01BQUEsVUFBQSxDQUFXLFdBQVgsRUFBd0IsR0FBeEIsRUFBQTs7QUFDQSxXQUFPO0VBVndCLENBQWhDO0VBWUEsSUFBVyxLQUFYO0lBQUEsS0FBQSxDQUFBLEVBQUE7O0FBOUhDLENBQUYifQ==
